import * as Scrivito from "scrivito"

import { PortfolioPage } from "pages/portfolio-page/PortfolioPage"

import { PortfolioPageObjClass } from "./PortfolioPageObjClass"

Scrivito.provideComponent(PortfolioPageObjClass, PortfolioPage)
